import React from 'react';
import { Target, Mail, Users, BarChart3, Search, MessageSquare, ArrowRight } from 'lucide-react';
export function Services() {
  const services = [{
    title: 'B2B Lead Generation',
    description: 'We identify and connect with decision-makers at companies that need your products or services.',
    icon: <Target className="h-8 w-8 text-amber-500" data-id="element-277" />
  }, {
    title: 'Email Marketing',
    description: 'Strategic email campaigns that nurture leads through the sales funnel with personalized messaging.',
    icon: <Mail className="h-8 w-8 text-amber-500" data-id="element-278" />
  }, {
    title: 'Social Media Marketing',
    description: 'Engage prospects where they spend their time with targeted social media lead generation strategies.',
    icon: <Users className="h-8 w-8 text-amber-500" data-id="element-279" />
  }, {
    title: 'Analytics & Reporting',
    description: 'Comprehensive reporting dashboards that track performance metrics and ROI for all campaigns.',
    icon: <BarChart3 className="h-8 w-8 text-amber-500" data-id="element-280" />
  }, {
    title: 'SEO Optimization',
    description: 'Improve your visibility in search results to attract more qualified organic leads to your business.',
    icon: <Search className="h-8 w-8 text-amber-500" data-id="element-281" />
  }, {
    title: 'Conversion Optimization',
    description: 'Turn more visitors into leads with optimized landing pages and conversion funnels.',
    icon: <MessageSquare className="h-8 w-8 text-amber-500" data-id="element-282" />
  }];
  return <section id="services" className="py-28 bg-white" data-id="element-283">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-284">
        <div className="text-center mb-20" data-id="element-285">
          <div className="inline-block px-3 py-1 text-xs font-semibold text-amber-600 bg-amber-100 rounded-full mb-4" data-id="element-286">
            Our Services
          </div>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4" data-id="element-287">
            Comprehensive Lead Generation Solutions
          </h2>
          <p className="mt-4 max-w-2xl text-xl text-gray-500 mx-auto" data-id="element-288">
            We offer end-to-end lead generation services to help you attract,
            engage, and convert your ideal customers.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-289">
          {services.map((service, index) => <div key={index} className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 group hover:border-amber-100 hover:translate-y-[-5px]" data-id="element-290">
              <div className="h-16 w-16 bg-gradient-to-br from-amber-50 to-amber-100 rounded-xl flex items-center justify-center mb-6 group-hover:bg-gradient-to-br group-hover:from-amber-100 group-hover:to-amber-200 transition-colors" data-id="element-291">
                {service.icon}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-292">
                {service.title}
              </h3>
              <p className="text-gray-600 mb-6" data-id="element-293">{service.description}</p>
              <a href="#contact" className="inline-flex items-center text-amber-600 font-medium group/link" data-id="element-294">
                Learn more
                <ArrowRight className="ml-2 h-4 w-4 transition-transform duration-300 group-hover/link:translate-x-1" data-id="element-295" />
              </a>
            </div>)}
        </div>
        <div className="mt-24 text-center" data-id="element-296">
          <a href="#contact" className="inline-flex items-center px-8 py-4 border border-transparent text-lg font-medium rounded-lg shadow-lg text-white bg-gradient-to-r from-amber-400 to-red-400 hover:from-amber-500 hover:to-red-500 transition-all duration-300 hover:shadow-amber-500/20" data-id="element-297">
            Start Generating Leads
          </a>
        </div>
      </div>
    </section>;
}